var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaskManager = function SvgTaskManager(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M21 2H9v2h12zM1 6h6V0H1zm2-4h2v2H3zM21 10H9v2h12zM21 18H9v2h12zM1 22h6v-6H1zm2-4h2v2H3zM3 14.4l4.7-4.7-1.4-1.4L3 11.6l-1.3-1.3-1.4 1.4z"
  })));
};
export default SvgTaskManager;